import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRegions, selectLocalizationData } from './features/localization/localizationSlice.js';
// import { getRegionFromQuery } from './features/localization/localizationSlice.js';

const RegionalPriceSet = () => {
  const dispatch = useDispatch();
  const localization = useSelector(selectLocalizationData);

  useEffect(() => {
    // This will return 'CA' if the URL has ?region=CA, otherwise 'US'
    // const clientRegion = getRegionFromQuery();
    // console.log('Regional price set query region', clientRegion, localization.region);
    // if (localization.region !== clientRegion) {
    //   dispatch(setRegions(clientRegion));
    // }
  }, [ dispatch, localization.region ]);
  return null;
};

export default RegionalPriceSet;
